import {
  GET_LIST,
  GET_MANY,
  GET_ONE,
  CREATE,
  UPDATE,
  UPDATE_MANY,
  DELETE,
  DELETE_MANY,
} from "vuetify-admin/src/providers/data/actions";

import FetchHydra from "vuetify-admin/src/providers/utils/fetchHydra";
import objectToFormData from "vuetify-admin/src/providers/utils/objectToFormData";
import qs from "qs";

export default (httpClient) => {
  if (typeof httpClient === "string") {
    httpClient = new FetchHydra(httpClient);
  }

  return {
    [GET_LIST]: (resource, params) => {
      const { pagination, sort, filter } = params;

      let query = filter || {};

      if (pagination) {
        query = {
          ...query,
          page: pagination.page,
          itemsPerPage: pagination.perPage,
        };
      }

      if (sort && sort.length) {
        query.order = {};

        sort.forEach((item) => {
          let { by, desc } = item;

          query.order[by] = desc ? "desc" : "asc";
        });
      }

      return httpClient.get(
        `${resource}?${qs.stringify(query, { arrayFormat: "repeat" })}`
      );
    },
    [GET_MANY]: (resource, params) =>
      Promise.all(
        params.ids.map((id) => {
          return httpClient.get(
            `${resource}/${
              isNaN(id) ? (id.user !== undefined ? id.user.uuid : id.substring(id.lastIndexOf("/") + 1) ) : id
            }`
          );
        })
      ).then((responses) => ({ data: responses.map(({ data }) => data) })),
    [GET_ONE]: (resource, params) => httpClient.get(`${resource}/${params.id}`),
    [CREATE]: (resource, params) => {
      let formData = objectToFormData(params.data);
      return httpClient.post(resource, formData);
    },
    [UPDATE]: (resource, params) => {
      let formData = objectToFormData(params.data);
      return httpClient.post(`${resource}/${params.id}?_method=PUT`, formData);
    },
    updateLight: (resource, params) => {
      let formData = objectToFormData(params.data);
      return httpClient.post(`${resource}/${params.id}/light?_method=PUT`, formData);
    },
    [UPDATE_MANY]: (resource, params) =>
      Promise.all(
        params.ids.map((id) => httpClient.put(`${resource}/${id}`, params.data))
      ).then(() => Promise.resolve()),
    [DELETE]: (resource, params) =>
      httpClient.delete(`${resource}/${params.id}`),
    [DELETE_MANY]: (resource, params) =>
      Promise.all(
        params.ids.map((id) => httpClient.delete(`${resource}/${id}`))
      ).then(() => Promise.resolve()),
  };
};
